window.addEventListener("load", function () {
    $(document).ready(function () {
    if ($(window).width() > 769) {
        initSwipers();
    }
});

function initSwipers() {
    var swiperprelated = new Swiper(".relatedswiper", {
        slidesPerView: 4,
        spaceBetween: 10,
        wrapperClass: 'relatedwrpper',
        slideClass: 'relatedslide',
        breakpoints: {
            300: { slidesPerView: 1.25, spaceBetween: 8 },
            768: { slidesPerView: 2.75, spaceBetween: 10 },
            1024: { slidesPerView: 3, spaceBetween: 24 },
            1440: { slidesPerView: 4, spaceBetween: 24 },
        },
    });

    var swiperprocess = new Swiper(".process-swiper", {
        slidesPerView: 5,
        spaceBetween: 10,
        wrapperClass: 'process-wrapper',
        slideClass: 'process-slide',
        breakpoints: {
            300: { slidesPerView: 1.25, spaceBetween: 8 },
            768: { slidesPerView: 3, spaceBetween: 10 },
            1024: { slidesPerView: 4, spaceBetween: 16 },
            1440: { slidesPerView: 5, spaceBetween: 16 },
        },
    });
}
    var swipercase = new Swiper(".case-swiper", {
        slidesPerView: 5.24,
        spaceBetween: 10,
        wrapperClass: 'case-wrapper',
        slideClass: 'case-slide',

        breakpoints: {
            300: {
                slidesPerView: 1.25,
                spaceBetween: 8,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 4.25,
                spaceBetween: 24,
            },
            1440: {
                slidesPerView: 5.25,
                spaceBetween: 24,
            },
        },
    });

    var swiperproduct = new Swiper(".product-swiper", {
        slidesPerView: 3,
        spaceBetween: 10,
        wrapperClass: 'product-swiper-wrapper',
        slideClass: 'product-slide',
        grabCursor: true,
        centeredSlides: false,
        navigation: {
            nextEl: '.next2',
            prevEl: '.prev2',
        },
        breakpoints: {
            300: {
                slidesPerView: 1.25,
                spaceBetween: 8,
                centeredSlides: true,
            },
            767: {
                centeredSlides: true,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1440: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
        },
    });

var swiperaward = new Swiper(".award-swiper", {
  slidesPerView: 4,
  spaceBetween: 110,
  wrapperClass: "award-wrapper",
  slideClass: "award-slide",
  loop: true, // no Swiper loop, we handle it manually
  freeMode: true,
  speed: 5000, // higher = slower scroll
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  breakpoints: {
    300: { slidesPerView: 1.25, spaceBetween: 10 },
    768: { slidesPerView: 2.25, spaceBetween: 50 },
    1024: { slidesPerView: 3.25, spaceBetween: 50 },
    1440: { slidesPerView: 4, spaceBetween: 50 },
    1660: { slidesPerView: 4, spaceBetween: 110 },
  },
});

var swiperabout = new Swiper(".about-swiper", {
        slidesPerView: 3.25,
        spaceBetween: 24,
        wrapperClass: 'about-wrapper',
        slideClass: 'about-slide',
        loop:true,
         navigation: {
            nextEl: '.next4',
            prevEl: '.prev4',
        },
        breakpoints: {
            300: {
                slidesPerView: 1.25,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1440: {
                slidesPerView: 3.25,
                spaceBetween: 24,
            },
        },
    });

    var swiperaboutgrid = new Swiper(".grid-about-swiper", {
        slidesPerView: 2.75,
        spaceBetween: 24,
        wrapperClass: 'grid-about-wrapper',
        slideClass: 'grid-about-slide',
        pagination: {
            el: '.grid-progress',
            type: 'progressbar',
        },
         navigation: {
            nextEl: '.next5',
            prevEl: '.prev5',
        },
        breakpoints: {
            300: {
                slidesPerView: 1.25,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2.25,
                spaceBetween: 20,
            },
            1440: {
                slidesPerView: 2.75,
                spaceBetween: 24,
            },
        },
    });

    var swiperstore = new Swiper(".store-swiper", {
        slidesPerView: 4.25,
        spaceBetween: 24,
        wrapperClass: 'store-wrapper',
        slideClass: 'store-slide', 
        navigation: {
            nextEl: '.next1',
            prevEl: '.prev1',
        },
        pagination: {
            el: '.store-progress',
            type: 'progressbar',
        },
        breakpoints: {
            300: {
                slidesPerView: 1.25,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 2.125,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3.125,
                spaceBetween: 20,
            },
            1440: {
                slidesPerView: 3.75,
                spaceBetween: 24,
            },
            1556: {
                slidesPerView: 4.25,
                spaceBetween: 24,
            },
        },
    });

    var swipercustomer = new Swiper(".customer-swiper", {
        slidesPerView: 4,
        spaceBetween: 10,
        wrapperClass: 'customer-wrapper',
        slideClass: 'customer-slide',
        navigation: {
            nextEl: '.next',
            prevEl: '.prev',
        },
        breakpoints: {
            300: {
                slidesPerView: 1.25,
                spaceBetween: 8,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
    });

    $(document).ready(function () {
        var $button = $('.buttonpopup');
        var $popup = $('.popup-block');
        var $closeBtn = $('.close-popup');
        var $video = $('.popup_banner');

        $button.on('click', function () {
            $popup.show();
            $video[0].play();
        });

        $closeBtn.on('click', function () {
            $popup.hide();
            $video[0].pause();
        });
    });

    const lenis = new Lenis({ smoothWheel: true, duration: 2, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), })
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf)


    $(window).on('scroll', function () {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var documentHeight = $(document).height();

        // Check if reached (or nearly reached) the bottom
        if (scrollTop + windowHeight >= documentHeight - 10) {
            $('.bluer_section').addClass('deactive');
        } else {
            $('.bluer_section').removeClass('deactive');
        }
    });

    var fade_elements = gsap.utils.toArray('[gsap-fade-in]')
    fade_elements.forEach(function (element) {
        var tl = gsap.timeline({ scrollTrigger: { trigger: element, start: 'top bottom', end: 'bottom top', toggleActions: 'play none play none', }, })
        tl.fromTo(element, { opacity: 0, y: '20%' }, { opacity: 1, y: '0%', duration: 1 })
    })

    const cursor = document.querySelector('.mouse-cursor');
    const gallery = document.querySelector('.case-swiper');
    const product_gallery = document.querySelector('.main-swiper');

    if (cursor && gallery) {
        let posX = 0, posY = 0;
        let mouseX = 0, mouseY = 0;

        gsap.ticker.add(() => {
            posX += (mouseX - posX) / 9;
            posY += (mouseY - posY) / 9;
            gsap.set(cursor, { x: posX - 12, y: posY - 12 });
        });

        document.addEventListener('mousemove', e => {
            mouseX = e.clientX;
            mouseY = e.clientY;
        });

        gallery.addEventListener('mouseleave', () => cursor.style.opacity = 0);
        gallery.addEventListener('mouseenter', () => cursor.style.opacity = 1);
        product_gallery.addEventListener('mouseleave', () => cursor.style.opacity = 0);
        product_gallery.addEventListener('mouseenter', () => cursor.style.opacity = 1);
    }

    if ($(window).width() > 769) {
        $(document).ready(function () {
            $('.mwrpa').on('mouseenter', function () {
                $('.mwrpa').removeClass('active');
                $(this).addClass('active');
            });
            $('.mwrpa').on('mouseleave', function (e) {
                const $this = $(this);
                const related = e.relatedTarget;
                if (!$.contains($this[0], related)) {
                    $this.removeClass('active');
                }
            });
        });
    }

    $(document).ready(function () {
        var $navbar = $('.shopify-section--header');
        var $toolbar = $('.collection-toolbar');
        var lastScrollTop = 0;

        $(window).on('scroll', function () {
            var scrollTop = $(this).scrollTop();

            // Near the top — remove everything
            if (scrollTop <= 50) {
                $navbar.removeClass('active bgcolor');
                $toolbar.removeClass('color');
            }
            // Scrolling down
            else if (scrollTop > lastScrollTop) {
                $navbar.addClass('active bgcolor');
                $toolbar.addClass('color');
            }
            // Scrolling up
            else if (scrollTop < lastScrollTop) {
                $navbar.removeClass('active');
                $toolbar.removeClass('color');
            }

            lastScrollTop = scrollTop;
        });
    });

});
let typeSplit = new SplitType("[text-split]", {
    types: "words, chars",
    tagName: "span"
});

function createScrollTrigger(triggerElement, timeline) {
    ScrollTrigger.create({
        trigger: triggerElement,
        start: "top 85%",
        onEnter: () => timeline.play()
    });
}

$("[letters-slide-up]").each(function () {
    let tl = gsap.timeline({ paused: true });

    tl.from($(this).find(".word"), {
        y: 40,
        opacity: 0,
        filter: "blur(8px)",
        skewX: -10,
        transformOrigin: "left center",
        duration: 0.6,
        ease: "power3.out",
        stagger: { amount: 0.3 }
    });

    createScrollTrigger($(this), tl);
});

$("[scroll-scrub]").each(function () {
    gsap.fromTo($(this).find(".word"),
        {
            y: 40,
            opacity: 0,
            filter: "blur(8px)",
            skewX: -10
        },
        {
            y: 0,
            opacity: 1,
            filter: "blur(0px)",
            skewX: 0,
            ease: "power3.out",
            stagger: { amount: 0.4 },
            scrollTrigger: {
                trigger: this,
                start: "top 90%",
                end: "top 30%",
                scrub: true // <- makes it sync with scroll
            }
        }
    );
});

gsap.set("[text-split]", { opacity: 1 });

gsap.registerPlugin(ScrollTrigger);

$(".scale-up").each(function () {
    gsap.fromTo(this,
        {
            scale: 0,
            opacity: 0
        },
        {
            scale: 1,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
                trigger: this,
                start: "top 85%",
                toggleActions: "play none none none",
                once: true
            }
        }
    );
});

$('.open-cart').on('click', function () {
    $('.easc-stickyCartDiv').trigger('click')
})
